import styled from "styled-components"

export const CardType = styled.div`
  width : 200px;
  padding : 16px;
  background : #212E4D;
  box-shadow : 1px 1px 1px #000;
  -webkit-box-shadow : 1px 1px 17px #fff;
  border-radius : 10px;
  display : flex;
  flex-direction : row;
  justify-content :center;
  align-items : center;
  text-align : center;
  cursor : pointer;
  margin-bottom : 20px;
  margin-right : 10px;

    box-shadow: 1px 1px 2px #000;  
    -webkit-box-shadow: -1px 1px 12px rgba(0,0,0,.3);

  ${({ color }) => {
    if (color) {
      return `background : #fff`
    }
  }}
`

export const LabelType = styled.p`
  ${({ color }) => {
    if (color) {
      return `color : #000`
    } else {
      return `color : #fff`
    }
  }}
`



export const ContainerTypes = styled.div`
  width : 100%;
  flex-wrap : wrap;
  display : flex;
  flex-direction : row;
  justify-content :center;
  align-items : center;
  text-align : center;
  margin-bottom : 20px;
`


export const ContainerAgendamento = styled.div`
  width : 100%;
  padding : 10px;
  box-shadow: 1px 1px 2px #000;
  -webkit-box-shadow: -1px 1px 12px rgba(0,0,0,.3);
  background : #fff;
  margin-bottom : 40px;
  display : flex;
  flex-direction : column;
  border-radius : 10px;

  flex-direction : column;
  align-items : center;
  justify-content :space-around;
`

export const HeaderAgendamento = styled.div`
  display : flex;
  flex-direction : column;
  align-items : center;
  justify-content :space-around;
  width : 100%;
  height : 200px;
`


